import { EUnitOfMeasure } from '../shared/enum';
import { TInputDrainageChimney } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

export const configuration: TInputDrainageChimney = 'configuration';
export const drainageChimneyHeight: TInputDrainageChimney = 'drainageChimneyHeight';
export const drainageChimneyWidth: TInputDrainageChimney = 'drainageChimneyWidth';
export const drainageChimneyLength: TInputDrainageChimney = 'drainageChimneyLength';
export const coverLayer: TInputDrainageChimney = 'coverLayer';
export const chimneyWheelbase: TInputDrainageChimney = 'chimneyWheelbase';

export const drainageChimneyPD = {
    [configuration]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: '',
            [EUnitOfMeasure.Imperial]: '',
        },
    },
    [drainageChimneyHeight]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainageChimneyWidth]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [drainageChimneyLength]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [coverLayer]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
    [chimneyWheelbase]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.meter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.foot,
        },
    },
};
